<template>
    <div class="end">
        <div class="user">
            <img class="user-img" :src="$store.state.user.avatar" :onerror="defaultImg">
            <p class="user-name">{{$store.state.user.nickName}}</p>
            <p class="user-title">获得<span>{{title.name}}</span>称号</p>
        </div>
        <div class="btn-group">
            <div class="btn show-btn" @click="handleShow">炫耀成就</div>
            <div class="btn again-btn" @click="handleHome">再次挑战</div>
        </div>
        <div class="barrage-content">
            <Barrage />
        </div>
    </div>
</template>
<style lang="scss" scoped>
.end {
    .user {
        margin: .15rem auto 0 auto;
        padding-bottom: .15rem;
        width: 3.55rem;
        height: 2.27rem;
        background: url('~@/assets/images/bg_img_top.png') no-repeat;
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .user-img {
            width: .5rem;
            height: .5rem;
            border-radius: 50%;
            border: .015rem solid #777DEB;
            box-sizing: content-box;
            margin-top: .1rem;
        }
        .user-name {
            margin-top: .05rem;
            font-size: .15rem;
            font-weight: 500;
            color: #232425;
        }
        .user-title {
            margin-top: .25rem;
            font-size: .18rem;
            color: #333333;
            span {
                padding: 0 .05rem;
                font-size: .24rem;
                font-weight: 500;
                color: #585FE4;
            }
        }
    }
    .btn-group {
        display: flex;
        justify-content: center;
        margin-top: .3rem;
        .btn {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 1.44rem;
            height: .48rem;
            border-radius: .24rem;
            background: #ffffff;
            color: #454545;
            font-size: .19rem;
            font-weight: 500;
        }
        .show-btn {
            background: #10CDA3;
            color: #ffffff;
        }
        .again-btn {
            margin-left: .215rem;
        }
    }
    .barrage-content { margin-top: .7rem; }
}
</style>
<script>

import Barrage from '@/components/Barrage.vue'
import {wechatShare} from '@js/api'

export default {

    components: {
        Barrage
	},

    computed: {
        defaultImg () {
            return 'this.src="'+ require('../assets/images/default.jpeg') +'"';
        }
    },

    methods: {
        handleShow(){ this.$router.push('/Poster'); },
        handleHome(){ this.$router.push('/'); },

        hanleGetTitle(){
            let userDesignation = window.sessionStorage.getItem("userDesignation");
            this.title.name = userDesignation;
        },

    },

    mounted(){
        wechatShare();
        this.hanleGetTitle();
    },

    destroyed(){
	},

    data(){
        return {
            title: {
                name: '',
                text: []
            },
        }
    }
}
</script>